import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Mixpanel } from '@/analytics/mixpanel'
import BooksBlock from '@/app/components/listing/BooksBlock.vue'
import MultiDocsBlock20321 from '@/app/components/listing/MultiDocsBlock20321.vue'
import { vOnVisible } from '@/helpers/directives'
import type { ListView } from '@/models/docs.list'
import type { ListItem } from '@/models/interfaces'
import { saveForLater20321Variant } from '@/services/ab/experiments'


export default /*@__PURE__*/_defineComponent({
  __name: 'WantToReadBooksBlock',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

/** Track the block impression using the full list size. */
function trackImpression(): void {
  Mixpanel.trackWantToReadBlockImpression(props.view.dataLength)
}

/** Return the Want to Read details added to this book's Doc View event. */
function docViewEventProperties(doc: ListItem): Record<string, unknown> {
  return {
    'Want to Read List Size': props.view.dataLength,
    'Want to Read Is Onboarding Seeded':
      props.view.customList?.onboarding_doc_ids?.includes(doc.id) ?? false,
  }
}

return (_ctx: any,_cache: any) => {
  return (_unref(saveForLater20321Variant)() === 'B')
    ? _withDirectives((_openBlock(), _createBlock(MultiDocsBlock20321, {
        key: 0,
        view: __props.view,
        showFreeBooks: "",
        docViewEventProperties: docViewEventProperties
      }, null, 8, ["view"])), [
        [
          _unref(vOnVisible),
          trackImpression,
          void 0,
          { once: true }
        ]
      ])
    : _withDirectives((_openBlock(), _createBlock(BooksBlock, {
        key: 1,
        view: __props.view,
        docViewEventProperties: docViewEventProperties
      }, null, 8, ["view"])), [
        [
          _unref(vOnVisible),
          trackImpression,
          void 0,
          { once: true }
        ]
      ])
}
}

})